import { api } from '../client'
import { ENDPOINTS } from '../config'
import { AuthLoginResponse, MeResponse, ParentRecord } from '../types'

export interface LoginPayload {
    email: string
    password: string
}

export interface SignupPayload {
    email: string
    password: string
    firstName: string
    lastName: string
    [key: string]: unknown
}

export interface UpdateProfilePayload {
    firstName?: string
    lastName?: string
    phoneNumber?: string
    picture?: string
    relationship?: string
    address?: string
    city?: string
    state?: string
    country?: string
    branchId?: string
    [key: string]: unknown
}

export const AuthService = {
    login: (payload: LoginPayload) =>
        api.post<AuthLoginResponse>(ENDPOINTS.AUTH.LOGIN, payload, { skipAuth: true }),

    signup: (payload: SignupPayload) =>
        api.post<AuthLoginResponse>(ENDPOINTS.AUTH.SIGNUP, payload, { skipAuth: true }),

    getMe: () => api.get<MeResponse>(ENDPOINTS.AUTH.ME),

    /** Parent record for the current user. Returns null if the user is not a parent. */
    getParentMe: async (): Promise<ParentRecord | null> => {
        try {
            return await api.get<ParentRecord>(ENDPOINTS.PARENTS.ME)
        } catch {
            return null
        }
    },

    updateProfile: (payload: UpdateProfilePayload) =>
        api.patch<{ success: boolean }>(ENDPOINTS.AUTH.ME, payload),

    forgotPassword: (email: string) =>
        api.post<{ success: boolean; message?: string }>(
            ENDPOINTS.AUTH.FORGOT_PASSWORD,
            { email },
            { skipAuth: true }
        ),

    changePassword: (payload: { oldPassword?: string; newPassword: string }) =>
        api.post<{ success: boolean }>(ENDPOINTS.AUTH.CHANGE_PASSWORD, payload),

    deleteAccount: () => api.delete<{ success: boolean }>(ENDPOINTS.AUTH.DELETE_ACCOUNT)
}
